import { FunnelStartedFields, TestStartedFields, UserEventHandler, ViewContentFields } from '@xylabs/pixel'
import { ProcessPaymentResult } from '@xylabs/sdk-coin-js'
import { delay } from '@xylabs/sdk-js'

import { AddressInfoData } from '../models'

export abstract class CoinUserEventHandlerBase<T> extends UserEventHandler<T> {
  async pageView(_url: string) {
    await delay(0)
  }
  eventId?: string
  registerEventId = (eventId: string) => {
    this.eventId = eventId
    return this
  }
  abstract contactInfoComplete(): Promise<void>
  abstract addressInfoComplete(addressInfo?: AddressInfoData): Promise<void>
  abstract paymentInfoComplete(): Promise<void>
  abstract addToCart(): Promise<void>
  abstract initiateCheckout(): Promise<void>
  abstract purchaseAttempted(): Promise<void>
  abstract trialStarted(): Promise<void>
  abstract purchaseFailed(): Promise<void>
  abstract purchaseCompleted(payment: ProcessPaymentResult): Promise<void>
  abstract upsellViewed(): Promise<void>
  abstract upsellUnavailable(): Promise<void>
  abstract upsellAccepted(): Promise<void>
  abstract upsellSucceeded(): Promise<void>
  abstract upsellFailed(): Promise<void>
  abstract viewContent(fields: ViewContentFields): Promise<void>
  abstract testStarted(fields: TestStartedFields): Promise<void>
  abstract funnelStarted(fields: FunnelStartedFields): Promise<void>
  abstract emailCollected(fields: { email: string }): Promise<void>
  abstract accountCreated(): Promise<void>
  abstract shareCompleted(): Promise<void>
  abstract buyticketsCompleted(): Promise<void>
  abstract installCompleted(): Promise<void>
  abstract funnelCompleted(): Promise<void>
  abstract offerRequested(fields: { id: string }): Promise<void>
  abstract feedbackScoreCollected(fields: { score: string | number }): Promise<void>
  abstract feedbackSourceCollected(fields: { source: string }): Promise<void>
  abstract goodFeedbackRequested(): Promise<void>
  abstract badFeedbackRequested(): Promise<void>
  abstract customEvent(name: string, data?: T): Promise<void>
}
